export function toPrice() {
    price($(`.price[data-percent]`));
}

function price(e) {
    const basicPrice = Number($(`#basicprice`).text() / 100);
    (e).each(function () {
        $(this).html(formatPrice(($(this).data(`percent`) / 100) * basicPrice));
    });
}

function formatPrice(price) {
    let priceString = '';
    if (price == 0) {
        priceString = '';
    } else {
        price = parseFloat(price).toFixed(2);
        price = price.split('.');
        priceString = ` + &euro; ${price[0]},${price[1]}`;
    }
    return priceString;
}